import {
  getProfile,
  login,
  vcode,
  setModify,
  forget,
  avatar,
  notes,
  myOrders,
  cancelOrder,
  submitInvoiceInforApi,
  userinfo,
  password,
  requestRefund,
  agreement
} from '@/api/user'


// import {  getToken, removeToken,removeUid,removeInfo } from '@/utils/auth'

const user = {
  state: {
    isLogin: localStorage.getItem('isLogin') || false,
    userData: {},
    //公共删除消息弹窗
    public_model: {
      public_model_show: false,
      public_model_text: '',
      public_model_param: {}
    },
    site:{
        site_address:''
    }
  },
  mutations: {
    updateSite(state,param){
        state.site = param;
    },
    setLogin(state, params) {
      state.isLogin = true;
    },
    //退出登录清除用户信息
    reset(state) {
      Object.assign(state, {
        isLogin: false,
        userData: {}
      })
    },

    setUserInfo(state, params) {
      state.userData = params;
    },
    //关闭删除消息公共弹窗 , 清空值
    hide_public_model(state, param) {
      state.public_model = {
        public_model_show: false,
        public_model_text: '',
        public_model_param: {}
      };
    },
    //显示删除消息公共弹窗 
    show_public_model(state, param) {
      state.public_model = param;
    },
  },
  actions: {
    /**
     * 登录
     * @param {*} context 
     * @param {*} data 
     */
    login({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const {
            data
          } = response;
        //   if (data.code == 200) {
            // commit('setLogin', true)
        //   }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 获取验证码
     * @param {*} context 
     * @param {*} data 
     */
    vcode({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        vcode(userInfo).then(response => {
          const {
            data
          } = response;

          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 忘记密码
     * @param {*} context 
     * @param {*} data 
     */
    forget({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        forget(userInfo).then(response => {
          const {
            data
          } = response;

          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 退出登录
     * @param {*} context 
     * @param {*} data 
     */
    logout({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        console.log('执行了')
        localStorage.clear();
        // localStorage.removeItem('isLogin');
        // localStorage.removeItem('token');
        commit('reset');

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    },

    /**
     * 公共上传人脸头像
     * 上传base64
     * @param {*} param0 
     * @param {*} data 
     */
    avatar({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        avatar(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 获取用户信息
     * @param {*} context 
     * @param {*} data 
     */
    getProfile({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        getProfile({}).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 设置用户信息
     * @param {*} context 
     * @param {*} data 
     */
    setModify({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        setModify(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 学员须知
     * @param {*} context 
     * @param {*} data 
     */
    notes({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        notes(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 我的订单
     * @param {*} context 
     * @param {*} data 
     */
    myOrders({
        commit
      }, data) {
        return new Promise((resolve, reject) => {
          myOrders(data).then(response => {
            const {
              data
            } = response;
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      },

      /**
     * 取消订单
     * @param {*} context 
     * @param {*} data 
     */
    cancelOrder({
        commit
      }, data) {
        return new Promise((resolve, reject) => {
          cancelOrder(data).then(response => {
            const {
              data
            } = response;
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      },
  
    /**
     * 提交发票信息
     * @param {*} context 
     * @param {*} data 
     */
    submitInvoiceInforApi({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        submitInvoiceInforApi(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 获取用户信息
     * @param {*} context 
     * @param {*} data 
     */
    userinfo({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        userinfo(data).then(response => {
          const {
            data
          } = response;
          commit('setUserInfo', data.data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 获取用户信息
     * @param {*} context 
     * @param {*} data 
     */
    password({
      commit
    }, data) {
      return new Promise((resolve, reject) => {
        password(data).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 提交退款申请
     * @param {*} context 
     * @param {*} data 
     */
    requestRefund({
        commit
      }, data) {
        return new Promise((resolve, reject) => {
          requestRefund(data).then(response => {
            const {
              data
            } = response;
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      },

      /**
     * 用户协议
     * @param {*} context 
     * @param {*} data 
     */
    agreement({
        commit
      }, data) {
        return new Promise((resolve, reject) => {
          agreement(data).then(response => {
            const {
              data
            } = response;
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      },

    



    /**
     * 弹窗
     */
    public_model_sure({
      dispatch,
      commit
    }) {
      commit('hide_public_model');
    },
  },






}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js